import { Button, Typography } from '@mui/material'
import { PortalPageFrame } from '../common'
import { Link } from '../common/primitives'
import { portalUrl } from '../config'

const Portal = () => (
  <PortalPageFrame
    title="Model Manager"
    actions={
      <>
        <Button color="secondary" variant="contained" href="/navigator">
          Data Navigator
        </Button>
        <Button color="secondary" variant="contained" href={portalUrl}>
          Portal
        </Button>
      </>
    }
  >
    <Typography paragraph>
      Welcome to Awa's Model Manager. Navigate to the portal or contact Awa for
      help at <Link href="mailto:support@awa.kiwi">support@awa.kiwi</Link>.
    </Typography>
  </PortalPageFrame>
)

export default Portal
